import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import DashboardPage from '../pages/DashboardPage';
import useUser from '../hooks/useUser';
import LoginPage from '../pages/LoginPage';
import { withAuthLayout } from '../layouts/AuthLayout';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import { withDashboardLayout } from '../layouts/DashboardLayout';
import CompanyPage from '../pages/CompanyPage';
import UsersPage from '../pages/UsersPage';
import ProfilePage from '../pages/ProfilePage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';

const PATHS = {
  PUBLIC_PAGES: {
    PRIVACY: '/privacy'
  },
  AUTH_PAGES: {
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password'
  },
  LOGGED_PAGES: {
    DASHBOARD: '/',
    COMPANY: '/company',
    USERS: '/users',
    PROFILE: '/profile'
  }
};

const publicRoutes = () => {
  return (
    <>
      <Route path={PATHS.PUBLIC_PAGES.PRIVACY} Component={PrivacyPolicyPage} />
    </>
  );
};

const authRoutes = () => {
  return (
    <>
      <Route
        path={PATHS.AUTH_PAGES.LOGIN}
        Component={withAuthLayout(LoginPage)}
      />
      <Route
        path={PATHS.AUTH_PAGES.FORGOT_PASSWORD}
        Component={withAuthLayout(ForgotPasswordPage)}
      />
    </>
  );
};

const loggedRoutes = () => {
  return (
    <>
      <Route
        path={PATHS.LOGGED_PAGES.DASHBOARD}
        Component={withDashboardLayout(DashboardPage)}
      />
      <Route
        path={PATHS.LOGGED_PAGES.COMPANY}
        Component={withDashboardLayout(CompanyPage)}
      />
      <Route
        path={PATHS.LOGGED_PAGES.USERS}
        Component={withDashboardLayout(UsersPage)}
      />
      <Route
        path={PATHS.LOGGED_PAGES.PROFILE}
        Component={withDashboardLayout(ProfilePage)}
      />
    </>
  );
};

const AppRoutes = () => {
  const user = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const publicPages = [
      PATHS.AUTH_PAGES.LOGIN,
      PATHS.AUTH_PAGES.FORGOT_PASSWORD,
      ...Object.values(PATHS.PUBLIC_PAGES)
    ];
    const pathname = location.pathname.replace(/\/+$/, '') || '/';
    if (!user && !publicPages.includes(pathname)) {
      navigate(PATHS.AUTH_PAGES.LOGIN);
    }
    if (user && publicPages.includes(pathname)) {
      navigate(PATHS.LOGGED_PAGES.DASHBOARD);
    }
  }, [navigate, location.pathname, user]);

  return (
    <Routes>
      {publicRoutes()}
      {authRoutes()}
      {loggedRoutes()}
    </Routes>
  );
};

export default AppRoutes;
